import { useSelector } from 'store'
import { messageColor } from 'types/ReferTypes'

/**
 * モーダル基本情報
 */
export const useOpen = (): [boolean] => {
  const open = useSelector((state) => state.ModalReducer.open)
  return [open]
}

/**
 * モーダルメッセージ情報
 */
export const useMessageModal = (): [messageColor, string] => {
  const messageColor = useSelector((state) => state.ModalReducer.messageColor)
  const message = useSelector((state) => state.ModalReducer.message)
  return [messageColor, message]
}
